import { Box, Breadcrumbs, Button, Stack, Typography } from '@mui/material';
import React from 'react';
import toast from 'react-hot-toast';
import FoodBoxTopSuccessComponent from './FoodBoxSuccessTopComponent';
import FoodBoxSuccessContentSection from './FoodBoxSussessContentSection';
import PlannerFooter from '../../../../Components/menu_planner/PlannerFooter';
import { useLocation, useNavigate } from 'react-router';
import { mealTypeEnum } from '../../../../utils/constants';
import { getMealById } from '../create_food_box/CreateFoodBoxApi';

const FoodBoxSuccessScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state;
  const { formType, mealId, isEditMode, isDefaultDinner, isDefaultLunch } =
    location.state;
  console.dir(data);

  const handleViewAllFoodBoxClick = () => {
    navigate('/food-boxes', {
      replace: true,
    });
  };

  const handleEditThisFoodBoxClick = async () => {
    const mealIdentifier = mealId ?? data?.id ?? data?.externalId;
    const fallbackMeal = {
      ...data,
      allergies: [...(data?.allergiesList ?? data?.allergies ?? [])],
    };

    let nextMeal = fallbackMeal;
    let toastId;

    if (mealIdentifier) {
      toastId = toast.loading('Loading latest meal...');

      try {
        const refreshedMealResponse = await getMealById(mealIdentifier);
        nextMeal = {
          ...refreshedMealResponse.data,
          allergies: [...(refreshedMealResponse.data?.allergies ?? [])],
        };
      } catch (error) {
        toast.error('Unable to load the latest meal. Opening the saved copy instead.');
      } finally {
        toast.dismiss(toastId);
      }
    }

    navigate('/food-boxes/edit-food-box', {
      state: { item: nextMeal },
      replace: true,
    });
  };

  const handleCreateAScheduleClick = () => {
    navigate('/schedules/create-schedule', { replace: true });
  };

  const handlePortionsClick = () => {
    navigate('/food-boxes/edit-food-box/portion-info', {
      state: { mealId: mealId, formType },
    });
  };

  return (
    <Box>
      <Box
        className='content-horizontal-margin'
        sx={{
          display: 'flex',
          flexDirection: 'column',
          rowGap: 3,
          mt: 3,
          mb: 3,
        }}
      >
        <Breadcrumbs aria-label='breadcrumb'>
          <Typography variant='s16_w500_orange'>Food Boxes</Typography>
        </Breadcrumbs>
        <FoodBoxTopSuccessComponent />
        <FoodBoxSuccessContentSection data={data} />
        <Stack
          direction='row'
          justifyContent='space-between'
          alignItems='center'
        >
          <Stack direction='row' alignItems='center' gap={2}>
            <Button variant='outlined' onClick={handleEditThisFoodBoxClick}>
              Edit this Food Box
            </Button>
            <Button variant='outlined' onClick={handleViewAllFoodBoxClick}>
              View all Food Boxes
            </Button>
          </Stack>
          {formType === mealTypeEnum.meal ? (
            !(isDefaultDinner || isDefaultLunch) ? (
              <Button variant='contained' onClick={handleCreateAScheduleClick}>
                Create a Schedule
              </Button>
            ) : null
          ) : (
            <Button variant='contained' onClick={handlePortionsClick}>
              {isEditMode ? 'Edit Portion' : 'Create Portion'}
            </Button>
          )}
        </Stack>
        <PlannerFooter />
      </Box>
    </Box>
  );
};

export default FoodBoxSuccessScreen;
